/** Join class names, dropping the falsy ones. Small on purpose: no clsx dependency. */
export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ');
}
